export default "__VITE_ASSET__hqR6M87c__"